import React from "react";
import { useNavigate } from "react-router-dom";
// nodejs library that concatenates classes
import classNames from "classnames";
import { axios } from "../../config/https";
import SocketService from "../../socket";
// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  NavbarToggler,
  ModalHeader,
} from "reactstrap";
import constants from "util/constans";

function AdminNavbar(props) {
  const navigate = useNavigate();

  const [collapseOpen, setcollapseOpen] = React.useState(false);
  const [modalSearch, setmodalSearch] = React.useState(false);
  const [notifications, setNotifications] = React.useState([]);
  const [color, setcolor] = React.useState("navbar-transparent");

  const loadNotifications = React.useCallback(() => {
    axios.get(`${constants.apiurl}/api/notifications`).then((result) => {
      if (result && result.data) {
        setNotifications(result.data);
      }
    });
  }, []);

  const notificationrefresh = React.useCallback(() => {
    loadNotifications();
  }, [loadNotifications]);

  const updateColor = React.useCallback(() => {
    if (window.innerWidth < 993 && collapseOpen) {
      setcolor("bg-white");
    } else {
      setcolor("navbar-transparent");
    }
  }, [collapseOpen]);

  React.useEffect(() => {
    window.addEventListener("resize", updateColor);

    const socket = new SocketService();
    socket.getSocket().on("notificationrefresh", notificationrefresh);

    return function cleanup() {
      window.removeEventListener("resize", updateColor);
      socket.disconnect();
    };
  }, [notificationrefresh, updateColor]);

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  // this function opens and closes the collapse on small devices
  const toggleCollapse = () => {
    if (collapseOpen) {
      setcolor("navbar-transparent");
    } else {
      setcolor("bg-white");
    }
    setcollapseOpen(!collapseOpen);
  };
  // this function is to open the Search modal
  const toggleModalSearch = () => {
    setmodalSearch(!modalSearch);
  };

  function notificationsOnclick() {
    setTimeout(() => {
      deleteNotifications();
    }, 5000);
  }

  function deleteNotifications() {
    axios.delete(`${constants.apiurl}/api/notification`).then(() => {
      setNotifications([]);
    });
  }

  return (
    <>
      <Navbar className={classNames("navbar-absolute", color)} expand="lg">
        <Container fluid>
          <div className="navbar-wrapper">
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}
            >
              <NavbarToggler onClick={props.toggleSidebar}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </NavbarToggler>
            </div>
            <NavbarBrand href="#" onClick={(e) => e.preventDefault()}>
              <img style={{ height: "5rem" }} alt="WANTRACK" src={require("assets/img/logo3.png")} />
            </NavbarBrand>
          </div>
          <NavbarToggler onClick={toggleCollapse}>
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </NavbarToggler>
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto" navbar>
              {/* <InputGroup className="search-bar">
                <Button color="link" onClick={toggleModalSearch}>
                  <i className="tim-icons icon-zoom-split" />
                  <span className="d-lg-none d-md-block">Search</span>
                </Button>
              </InputGroup> */}
              <UncontrolledDropdown nav>
                <DropdownToggle
                  onClick={notificationsOnclick}
                  caret
                  color="default"
                  data-toggle="dropdown"
                  nav
                >
                  {notifications.length > 0 ? <div className="notification d-none d-lg-block d-xl-block" /> : <div />}

                  <i className="tim-icons icon-sound-wave" />
                  <p className="d-lg-none">Notifications</p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">
                  <NavLink tag="li">
                    {notifications?.map((notification, index) => (
                      <DropdownItem key={notification.idnotification || notification.id || `${notification.text}-${index}`} className="nav-item">
                        {notification.text}
                      </DropdownItem>
                    ))}
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="photo">
                    <img alt="..." src={require("assets/img/anime3.png")} />
                  </div>
                  <b className="caret d-none d-lg-block d-xl-block" />
                  <p className="d-lg-none">Cerrar sesion</p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">Perfil</DropdownItem>
                  </NavLink>
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">Configuraciones</DropdownItem>
                  </NavLink>
                  <DropdownItem divider tag="li" />
                  <NavLink tag="li">
                    <DropdownItem className="nav-item" onClick={logout}>Cerrar sesion</DropdownItem>
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>
              <li className="separator d-lg-none" />
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      <Modal
        modalClassName="modal-search"
        isOpen={modalSearch}
        toggle={toggleModalSearch}
      >
        <ModalHeader>
          <Input placeholder="Buscar" type="text" />
          <button
            aria-label="Close"
            className="close"
            onClick={toggleModalSearch}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
        </ModalHeader>
      </Modal>
    </>
  );
}

export default AdminNavbar;
